import {
  aCreateMatchList,
  aMatchList,
  mockCreateMatchListOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const createMatchListHandler = ({
  id,
  name,
  description,
  timeToLiveInSeconds,
}) => ({
  __typename: 'Mutation',
  createMatchList: aCreateMatchList({
    data: aMatchList({
      name,
      description,
      defaultTtl: timeToLiveInSeconds,
      id,
      targetColumn: '1',
    }),
  }),
});

export const handlers = [
  mockCreateMatchListOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          createMatchList: aCreateMatchList(),
        },
      });
    }
  ),
];
